import { render, staticRenderFns } from "./horizontal-card-grid.vue?vue&type=template&id=d8b8bdde"
import script from "./horizontal-card-grid.vue?vue&type=script&lang=js"
export * from "./horizontal-card-grid.vue?vue&type=script&lang=js"
import style0 from "./horizontal-card-grid.vue?vue&type=style&index=0&id=d8b8bdde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports